var alignment_rtlignore_default = {
  "alignLeft": "Mub4V",
  "textWrapNowrap": "yajxI",
  "alignRight": "DceF6",
  "alignCenter": "-mt08",
  "sizeFullWidth": "k7CAy",
  "renderedInTable": "dRAG7",
  "sizeOriginal": "sWkd7",
  "sizeContent": "qzLL7",
  "sizeSmall": "KI4jA",
  "sizeSmallCenter": "YImzn",
  "flex": "osYx1",
  "LEFT": "I5wWX",
  "CENTER": "l96-p",
  "RIGHT": "BjVUa",
  "AUTO": "Iuy1K",
  "JUSTIFY": "nj55h"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
